import MainHeader from "../../components/layout/MainHeader";
import PageHeader from "../../components/layout/PageHeader";
import img from "../../assets/images/background/13a.jpg";
import Footer from "../../components/layout/Footer";
import RebarTab from "../../components/products/RebarTab";
function Rebar() {
  return (
    <>
      <MainHeader />
      <PageHeader image={img} title={"Steel Rebar"} />
      <RebarTab />
      <Footer />
    </>
  );
}

export default Rebar;
